export default __webpack_public_path__ + "static/media/y_sprint_6.e6fe5187.png";